import { inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';

import { DataListCnpjs } from '../models/responses/list-cnpj.response';
import { IZA_CNPJ_STREAM } from '../iza-config';

@Injectable({
  providedIn: 'root',
})
export class CnpjStoreService {
  private _selectedCnpj: WritableSignal<DataListCnpjs | null> = signal<DataListCnpjs | null>(null);

  readonly selectedCnpj: Signal<DataListCnpjs | null> = this._selectedCnpj.asReadonly();

  constructor() {
    // O CNPJ vem do host (Otimiza) via IZA_CNPJ_STREAM. A Iza apenas reflete a seleção.
    // Sem stream (ex.: testes), permanece null.
    inject(IZA_CNPJ_STREAM, { optional: true })?.subscribe(value => {
      const cnpj = (value ?? '').trim();
      this._selectedCnpj.set(cnpj ? { cnpj, nome_licenciado: '' } : null);
    });
  }
}
